import { render, staticRenderFns } from "./loginShe.vue?vue&type=template&id=125aa216&scoped=true&"
import script from "./loginShe.vue?vue&type=script&lang=js&"
export * from "./loginShe.vue?vue&type=script&lang=js&"
import style0 from "./loginShe.vue?vue&type=style&index=0&id=125aa216&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125aa216",
  null
  
)

export default component.exports